import { HttpService } from './../http-service';

import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Rx';
//import { catchError, map, tap } from 'rxjs/operators';
import 'rxjs/add/operator/toPromise';

import { User } from './../../domain/user';

@Injectable()
export class UserProvider {
  public user: User;

  constructor(public http: HttpService) {
  }

  getUserAuth(): Observable <User>{
      const url = '/user/getUserInfo';
      return this.http.get(url)
                .map(res => {
                  const userData = res.json().user.data;
                  // Criar instância real da classe User
                  const user = new User();
                  user.id = userData.id;
                  user.nome = userData.nome;
                  user.nivel = userData.nivel;
                  user.perfil = userData.perfil;

                  localStorage.setItem('currentUser', JSON.stringify(userData));

                  console.log('UserProvider: Usuário carregado:', user.nome, 'Perfil:', user.perfil ? user.perfil.nome : 'sem perfil');
                  return user;
                })
                .catch(err => {
                  console.error('UserProvider: Erro ao buscar usuário:', err);
                  return Observable.throw(err);
                });
  };

  /**
   * Log the user out, which forgets the session
   */
  logout() {
    this.user = null;
  }

  /**
   * Process a login/signup response to store user data
   */
  _loggedIn(resp) {
    this.user = resp.user;
  }

}



// WEBPACK FOOTER //
// ./src/providers/user/user.provider.ts